export default {
  label: {
    hot: '+ Calientes',
    new: '+ Nuevas',
    old: '+ Antigas',
    influence: '+ AAA',
    interactions: '+ Interacciones',
    shares: '+ Compartidas',
    likes: '+ Me gusta',
    comments: '+ Comentadas',
  },
};
